module.exports = __webpack_public_path__ + "static/img/our-people-we-live-hero-lowres.c8098f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-hero-lowres.jpg
// module id = Gya0
// module chunks = 0